export const MY_CLASSES_TITLE = 'My Classes'
export const TEACH_DESCRIPTION = 'Teach lessons to students and track progress'
export const NO_CLASSES_MESSAGE = 'Classes you create will appear here'
export const DIGITAL_WELL_BEING_CLASSES_TITLE = 'Digital Well-Being Classes'
export const DIGITAL_WELL_BEING_TEACH_DESCRIPTION =
  'To teach these lessons, create a class. To view these lessons, go to explore the program.'
export const EXPLORE_PROGRAM_TITLE = 'Explore the Program'
export const EXPLORE_PROGRAM_DESCRIPTION = 'Preview lessons and support'
export const NO_CLASSES_TRAINING_LINK =
  'If you have not yet completed training, go to'
